import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  mainCard: {
    minHeight: '40vh',
    height: '95%',
    width: '30vw',
    padding: '0px 0px 20px 0px',
    margin: '50px auto 50px auto',
  },
  mainGrid: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: 'auto',
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: '100%',
  },
  newFieldText: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto 20px auto',
    padding: '10px 0',
    fontSize: '20px',
    backgroundColor: theme.palette.primary.main,
  },

  fieldErrors: {
    color: theme.palette.error.main,
    margin: 'auto',
  },
  displayNameInput: {
    width: '200px',
    height: '40px',
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    padding: '0em 0em 0em .4em',
    margin: '0 auto 50px auto',
  },
  slugNameInput: {
    width: '300px',
    height: '30px',
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    padding: '0em 0em 0em .4em',
  },
  externalDefText: {
    display: 'flex',
    padding: '0 0 20px 0',
  },
  externalFieldIdText: {
    margin: '0px 160px 0 0',
  },
  displayName: {
    //display: 'flex',
    alignItems: 'center',
  },

  slug: {
    display: 'flex',
    alignItems: 'center',
  },

  displayNameText: {
    margin: '0 0 20px 0',
    //width: '100px',
  },
  slugText: {
    margin: '0 100px 0 0',
    width: '100px',
  },

  otherFieldType: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    margin: '0 0 0 0',
  },
  fieldType: {
    //display: 'flex',
    alignItems: 'center',
  },
  fieldTypeSelect: {
    width: '250px',
  },
  fieldTypeText: {
    margin: '0 90px 0 0',
    width: '110px',
  },
  titleWrapper: {
    display: 'flex',
  },
  displayTitle: {
    margin: '0 170px 0 210px',
  },
  choiceTitle: {},
  choicesInputs: {
    display: 'flex',
    margin: '0 0 0 0',
  },
  choicesSection: {
    justifyContent: 'flex-end',
    minHeight: '150px',
    maxHeight: '70vh',
    overflow: 'auto',
  },
  addOptionButton: {
    display: 'flex',
    margin: '10px 0 50px 0',
  },
  optionInput: {
    width: '245px',
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: '5px',
    padding: '0em 0em 0em .4em',
    margin: '0px 20px 10px 0px',
  },
  addCancelButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px 30px',
  },
  fieldDefinitionText: {
    margin: '0 0 0 0',
  },
}));

export default useStyles;
